import moment from "moment";
import numeral from "numeral";

export function formatToThaiDateTime(
  dateTimeString: string,
  includeTime: boolean = true
) {
  const thaiMonths = [
    "ม.ค.",
    "ก.พ.",
    "มี.ค.",
    "เม.ย.",
    "พ.ค.",
    "มิ.ย.",
    "ก.ค.",
    "ส.ค.",
    "ก.ย.",
    "ต.ค.",
    "พ.ย.",
    "ธ.ค.",
  ];

  const dt = moment(dateTimeString);
  const formattedDate = `${dt.date()} ${thaiMonths[dt.month()]} ${
    dt.year() + 543
  }`;
  const formattedTime = includeTime ? `, ${dt.format("HH:mm")}` : "";

  return `${formattedDate}${formattedTime}`;
}

export const getStorageAccessToken = () => {
  const accessToken = localStorage.getItem("accessToken");

  if (accessToken) {
    return accessToken;
  }

  return null;
};

export const formatMoney = (amount: number) => {
  return numeral(amount).format("0,0.00");
};

// TEMMED: ห้ามโชว์ b ท้ายยูสเด็ดขาด — เราแยกยูส (เติม b ตอนรับโปร) เพื่อกันการกั๊กฟรีสปิน
// ลูกค้าต้องไม่รู้ว่ามีการแยก. ใช้ gameusername (ยูสจริง ตามที่รีวิวสั่ง) แล้ว "ตัดตัวอักษรท้ายทิ้ง"
// ให้เหลือ tm+เบอร์ เสมอ — กันเคส bonususername ที่บางบัญชีก็ดันมี b ติดมา (ไม่นิ่ง)
export const maskUsername = (
  u?: { bonususername?: string; gameusername?: string; username?: string } | null
) => (u?.gameusername || u?.bonususername || "").replace(/[a-z]+$/i, "") || u?.username || "";
